import React from 'react';
import classNames from 'classnames';

import classes from '@nerdwallet/base-styles/classes';

import styles from './touchable.module.scss';

interface Props {
  block?: boolean;
  component?: string;
  children?: React.ReactNode;
}

interface ButtonProps extends Props, React.ComponentProps<'button'> {}
interface AProps extends Props, React.ComponentProps<'a'> {
  href: string;
}

/**
 * Touchable is a replacement for the deprecated <Link unstyled> pattern.
 *
 * If the basic NDS Link/Button doesn't work for your situation, Touchable makes your component
 * interactable (such as by using onClick/href/to props) while maintaining accessibility.
 */
const Touchable: React.FC<ButtonProps | AProps> = ({
  block = false,
  children,
  className,
  component,
  // @ts-expect-error not sure why this is failing
  href,
  ...props
}) => {
  const Component = component || (href ? 'a' : 'button');

  return (
    // @ts-expect-error -- Not sure why this is failing (Property children does not exist on type IntrinsicAttributes)
    <Component
      className={classNames(className, styles.touchable, {
        [styles.touchableButton]: Component === 'button',
        [classes('display-block')]: block,
        [classes('display-inline')]: !block,
      })}
      href={href}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Touchable;
